module.exports = __webpack_public_path__ + "img/banner1.f8cce1b4.jpg";